import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["range", "value"];

    declare readonly rangeTarget: HTMLInputElement;
    declare readonly valueTarget: HTMLInputElement;

    updateRange(): void {
        if (null ==  this.rangeTarget || null == this.rangeTarget.value ) {
            this.valueTarget.value = '';
            return;
        }

        let cleanValue = this.valueTarget.value.replace(/[^\d.,]/g, '');
        cleanValue = cleanValue.replace(/,/g, ".");
        let numericValue = parseFloat(cleanValue);

        if (isNaN(numericValue)) {
            this.valueTarget.textContent = '';
            return;
        } 

        this.valueTarget.value = numericValue.toLocaleString('fr-FR');
    }

    updateValue(): void{
        if (null ==  this.valueTarget || null == this.valueTarget.value ) {
            this.updateRange();
            return;
        }

        const scale = parseInt(this.valueTarget.dataset.scale || "", 10);

        let cleanValue = this.valueTarget.value.replace(/[^\d.,]/g, '');
        cleanValue = cleanValue.replace(/,/g, ".");
        let numericValue = parseFloat(cleanValue);

        if (isNaN(numericValue)) {
            this.updateRange();
            return;
        }

        this.rangeTarget.value = String(numericValue.toFixed(scale));
        this.valueTarget.value = numericValue.toLocaleString('fr-FR');

        this.syncPct();
        this.rangeTarget.dispatchEvent(new Event('change', { bubbles: true }));
    }

    private syncPct(): void {
        const el = this.rangeTarget;
        if (!el) return;
        const min = parseFloat(el.min) || 0;
        const max = parseFloat(el.max) || 100;
        const val = parseFloat(el.value) || 0;
        el.style.setProperty('--pct', `${((val - min) / (max - min)) * 100}%`);
    }
}